module.exports = publishpressFutureClassicEditorConfig;